var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar-container",style:(`height: ${_vm.height}px`)},[_c('div',{staticClass:"progress",style:(`max-width:${_vm.width}%;`)},[(_vm.innerText)?_c('span',{staticClass:"innerText font-weight-bold"},[_vm._v(_vm._s(_vm.innerText))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }